<template lang="pug">
  .site-container
    slot
</template>

<script>
export default {
  name: 'Default',
};
</script>
